import React, { ChangeEvent, Component, useContext, useEffect, useState } from "react";
import IErrorDTO from "../../../../../models/DTO/IErrorDTO";
import IGetVendorSourcesDTO from "../../../../../models/DTO/IGetVendorSourcesDTO";
import IOnGetVendorSourcesDTO from "../../../../../models/DTO/IOnGetVendorSourcesDTO";
import EndpointsEnum from "../../../../../models/EndpointsEnum";
import INotification from "../../../../../models/INotification";
import ISupplierModel from "../../../../../models/ISupplierModel";
import IUserUI from "../../../../../models/IUser";
import IVendor_Source from "../../../../../models/IVendor_Source";
import IVendorSourceItem from "../../../../../models/IVendorSourceItem";
import LeadTimeTypeEnum from "../../../../../models/LeadTimeTypeEnum";
import NotificationLevelEnum from "../../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../../models/NotificationPositionEnum";
import UnitOfMeasurementEnum from "../../../../../models/UnitOfMeasurementEnum";
import OwButton from "../../../../shared/OwButton/OwButton";
import OwInputWrapper from "../../../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../../../shared/OwSelectOption/OwSelectOption";
import Typeahead from "../../../../shared/Typeahead/Typeahead";
import "./VendorSourcesDetail.scss";
import OwCheckbox from "../../../../shared/OwCheckbox/OwCheckbox";
import { Socket } from "socket.io-client";
import ICatalog from "../../../../../models/ICatalog";
import IUiSocketSetup from "../../../../../models/IUiSocketSetup";
import UserContext from "../../../../../contexts/UserContext";
import SupplierContext from "../../../../../contexts/SupplierContext";
import { SocketContext } from "../../../../../contexts/SocketContext";
import UiContext from "../../../../../contexts/UiContext";
import { VendorSourceDetailRow } from "./VendorSourceDetailRow/VendorSourceDetailRow";
import ICatalog_Item from "../../../../../models/ICatalog_Item";
import ICatalog_ItemUI from "../../../../../models/ICatalog_ItemUI";
import IPrice_Bands_Structured from "../../../../../models/IPrice_Bands_Structured";
import IPrice_Band_Compiled from "../../../../../models/IPrice_Band_Compiled";
import IPrice_Group from "../../../../../models/IPrice_Group";
import UIService from "../../../../../services/UIService";

type Props = {
    catalogGuid: string;
    vendorSources: IVendorSourceItem[];
    updateVendorSourcesFn: (vendorSources: IVendorSourceItem[], defaultVendorSourceId?: number | null) => void;
    defaultVendorSourceId?: number | null;
    catalogModel: ICatalog;
    catalogItem?: ICatalog_ItemUI | null;
    priceBands: IPrice_Bands_Structured;
    handleBandUpdate: (band: IPrice_Band_Compiled[], priceGroup?: IPrice_Group, vendorSource?: IVendor_Source) => void;
};

export const VendorSourcesDetail = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const onGetVendorSources = (data: IOnGetVendorSourcesDTO) => {
        setFoundVendorSources(data.vendorSources);
    };

    const sockets: IUiSocketSetup[] = [{ endpoint: EndpointsEnum.PurchaseOrderOnGetVendorSources, fn: onGetVendorSources }];

    const [vendorSources, setVendorSources] = useState<IVendorSourceItem[]>(props.vendorSources);
    const [foundVendorSources, setFoundVendorSources] = useState<IVendor_Source[]>([]);
    const [selectedVendorSource, setSelectedVendorSource] = useState<IVendor_Source | null>(null);
    const [clearTypeahead, setClearTypeahead] = useState<boolean>(false);
    const [isDirty, setIsDirty] = useState<boolean>(false);

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        return () => {
            for (const _socket of sockets) {
                socket.off(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    useEffect(() => {
        setVendorSources(props.vendorSources);
    }, [props.vendorSources]);

    const getVendorSources = (name: string) => {
        const payload: IGetVendorSourcesDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            limit: 10,
            offset: 0,
            queryString: `?name=${name}`,
        };

        socket.emit(EndpointsEnum.PurchaseOrderGetVendorSources, payload);
    };

    const selectVendorSource = (source: IVendor_Source) => {
        setSelectedVendorSource(source);
    };

    const addVendorSource = () => {
        if (!selectedVendorSource) {
            return;
        }

        const vendorSource: IVendorSourceItem = {
            vendor_source_id: selectedVendorSource.id,
            priority: 1,
            uom_qty: 1,
            uom_qty_unit_of_measurement_id: UnitOfMeasurementEnum.EACH,
            min_order_qty: 1,
            unit_of_measurement_id: UnitOfMeasurementEnum.EACH,
            cost_price: 0,
            manuf_part_no: "",
            Vendor_Source: selectedVendorSource,
        };

        const _vendorSources = vendorSources;

        let found = false;

        if (_vendorSources) {
            for (const existingSource of _vendorSources) {
                if (vendorSource.vendor_source_id === existingSource.vendor_source_id) {
                    found = true;
                    break;
                }
            }
        }

        if (found) {
            const notification: INotification = {
                message: "error_duplicate_vendor_source",
                level: NotificationLevelEnum.error,
                position: NotificationPositionEnum.bc,
            };

            uiContext.notifyFn(null, notification);
        } else {
            _vendorSources.push(vendorSource);

            setVendorSources(_vendorSources);
            setClearTypeahead(true);
            // setState(
            //     {
            //         vendorSources,
            //         clearTypeahead: true,
            //     },
            //     () => {
            //         props.updateVendorSourcesFn(vendorSources);
            //     }
            // );
        }
    };

    const clearTypeaheadCallbackFn = () => {
        setClearTypeahead(false);
    };

    const removeSource = (source: IVendorSourceItem, index: number) => {
        const _vendorSources = vendorSources;

        let removed = false;

        for (const vendorSource of _vendorSources) {
            if (Number(vendorSource.vendor_source_id) === Number(source.vendor_source_id)) {
                if (vendorSource.id) {
                    vendorSource.deleteFlag = true;
                    removed = true;
                }
            }
        }

        if (!removed) {
            _vendorSources.splice(index, 1);
        }

        setVendorSources(_vendorSources);

        // setState(
        //     {
        //         vendorSources,
        //     },
        //     () => {
        //         props.updateVendorSourcesFn(vendorSources, defaultVendorSourceId);
        //     }
        // );
    };

    const handleDefaultVendorChange = (e: ChangeEvent<any>, source: IVendorSourceItem) => {
        console.log("handleDefaultVendorChange:", source.vendor_source_id);
        props.updateVendorSourcesFn(vendorSources, source.vendor_source_id);

        // setState(
        //     {
        //         defaultVendorSourceId: source.vendor_source_id,
        //     },
        //     () => {
        //         props.updateVendorSourcesFn(vendorSources, defaultVendorSourceId);
        //     }
        // );
    };

    const handleUpdateVendorSource = (source: IVendorSourceItem, index: number) => {
        const _vendorSources = vendorSources;

        _vendorSources[index] = source;

        setVendorSources(_vendorSources);
    };

    return (
        <div className="VendorSourcesDetail">
            <div>
                <div className={"d-flex w-100"}>
                    <div className={"flex-grow"}>
                        <Typeahead
                            title={"vendor_source_lookup"}
                            isSelectableFn={() => {
                                return true;
                            }}
                            typeaheadApiFn={getVendorSources}
                            selectedItem={selectedVendorSource}
                            typeaheadItems={foundVendorSources}
                            titleProp={"name"}
                            subTitleProp={"email"}
                            selectedItemFn={selectVendorSource}
                            clearTypeahead={clearTypeahead}
                            clearTypeaheadCallback={clearTypeaheadCallbackFn}
                        />
                    </div>
                    <div className={"ms-1"}>
                        <OwButton title={"add"} fn={addVendorSource} />
                    </div>
                </div>
            </div>

            <div>
                <div className={"d-flex"}>
                    <div className={"w-50"}>
                        <OwLabel title={"name"} isUnderline={true} isBold={true} />
                    </div>
                    <div className={"w-50"}>
                        <OwLabel title={"lead_time"} isUnderline={true} isBold={true} />
                    </div>
                </div>
                {vendorSources.map((source, index: number) => {
                    console.log("Sources Deail: ", props.defaultVendorSourceId);
                    return (
                        <div
                            key={source.vendor_source_id}
                            className={"card p-2 mt-4  " + (UIService.isMainViewLight() ? "" : "dark-card bg-dark text-white")}>
                            <VendorSourceDetailRow
                                source={source}
                                index={index}
                                defaultVendorSourceId={props.defaultVendorSourceId}
                                removeSource={removeSource}
                                handleDefaultVendorChange={handleDefaultVendorChange}
                                handleUpdateVendorSource={handleUpdateVendorSource}
                                handleBandUpdate={props.handleBandUpdate}
                                catalogItem={props.catalogItem}
                                band={props.priceBands[`${source.Vendor_Source?.name}_cost`] || []}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default VendorSourcesDetail;
